import {Component, OnDestroy, OnInit} from '@angular/core';
import { environment as ENV } from '../../../environments/environment';
import {BootstrapNotifyService} from '../../services/bootstrap-notify/bootstrap-notify.service';
import {UserService} from '../../services/apiCalls/userService/user.service';
import {IResponse, loginPayload} from '../../interfaces/iresponse';
import {NavigatorService} from '../../services/navigatorService/navigator.service';
import {CacheService} from '../../services/cacheService/cache.service';
import {AuthService} from "../../services/authService/auth.service";



interface imageCard{
  id: number,
  src: string,
  alt: string
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  public EMAIL_VALIDATION: any =  ENV.EMAIL_VALIDATION;
  public credentials = {
    email: null,
    password: null
  };
  cardTimer: any;
  cardImageIndex: number = 0;
  public userDetails: any;
  obscure:boolean = false;
  loaders = {
    login: false,
    showResetLink: false
  };
  constructor(private bootstrapNotify: BootstrapNotifyService,
              private userService: UserService,
              private cacheService: CacheService,
              private navigateService: NavigatorService,
              private authService: AuthService) {
                this.authService.logOut();
}

  imagesList: Array<imageCard> = [
    {id: 1, src: '../../../assets/images/logo/tax3.jpg', alt: 'logo'},
    {id: 2, src: '../../../assets/images/logo/tax2.jpg', alt: 'logo'},
    {id: 3, src: '../../../assets/images/logo/tax.jpg', alt: 'logo'},
  ]

  autoDisplayCard(){
    this.cardTimer = setInterval(() => {
      const index =  (this.cardImageIndex + 1)  % this.imagesList.length;
      this.cardImageIndex = index;
    }, 6000);
  }

  ngOnInit(): void {
    this.userDetails = null;
    this.autoDisplayCard();
  }
  public loginProcess() {
    this.loaders.login = true;
    this.cacheService.deleteSession(ENV.TOKEN);
    this.cacheService.deleteStorage(ENV.TOKEN);
    if (!this.credentials.email || !this.credentials.password) {
      this.bootstrapNotify.info('Provide login details!');
      this.loaders.login = false;
    } else {
      this.userService.auth(this.credentials as loginPayload).subscribe((response: IResponse) => {
        this.loaders.login = false;
        this.navigateService.navigateUrl(`/${response.data.user.role.toLowerCase()}/dashboard`);
      }, error => {
        this.bootstrapNotify.error(error.error && error.error.message || 'Unable to login', 'right');
        this.loaders.login = false;
      });
    }
  }

  togglePassword(){
    this.obscure =! this.obscure;
  }

  ngOnDestroy(): void {
    clearInterval(this.cardTimer);
  }
}
